import React from 'react';
import { number } from 'prop-types';

const ProgressBar = ({ progress }) => (
  <div
    role="progressbar"
    className="progress-determinate mdc-linear-progress mdc-linear-progress--accent"
  >
    <div className="mdc-linear-progress__buffering-dots" />
    <div className="mdc-linear-progress__buffer" />
    <div
      className="mdc-linear-progress__bar mdc-linear-progress__primary-bar"
      style={{ transform: `scaleX(${progress / 100})` }}
    >
      <span className="mdc-linear-progress__bar-inner" />
    </div>
    <div className="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
      <span className="mdc-linear-progress__bar-inner" />
    </div>
  </div>
);

ProgressBar.propTypes = {
  progress: number,
};

ProgressBar.defaultProps = {
  progress: 0,
};

export default ProgressBar;
